module.exports = __webpack_public_path__ + "img/banner9.a4a5ed4a.jpg";